import gql from 'graphql-tag';

export const GET_TIMEZONE = gql`
  query GetTimezone($lat: Float!, $lng: Float!) {
    getTimezone(lat: $lat, lng: $lng) {
      timeZone
    }
  }
`;
